import { Legend, DetailBar, Text, Button, Flex, Skeleton, notification } from "components/common"
import { IconText } from "components/custom"
import { t } from "i18next"
import theme from "utils/themeVars"
import { copyToClipboard } from "utils"
import { useCreateVIBANForContractMutation } from "features/shared/api"
import WhatsappCallButton from "features/clients/components/whatsapp-call-button"

const IBANInfo = ({
  clientId,
  contractId,
  clientIBAN,
  vIBAN,
  clientIbanRef,
  disableButton,
  loading,
  whatsappButtonDisabled,
}) => {
  const [creatingVIBAN, { isLoading: fetchingVIBAN, error }] = useCreateVIBANForContractMutation()

  if (loading) {
    return (
      <div>
        <Legend title={t("Bank Transfer Details")} />
        <Skeleton type="antparagraph" paragraph={{ rows: 1 }} />
      </div>
    )
  }
  return (
    <div>
      <Legend title={t("Bank Transfer Details")} />

      {!vIBAN ? (
        <>
          <Text type="secondary" className="mbe-20" style={{ fontSize: "12px" }}>
            {t(
              "Click on the button below to retrieve the banking details for further customer payments. Once a payment is made by the customer, they will automatically reflect in PropForce."
            )}
          </Text>

          <Flex vertical align="flex-start" gap="8px">
            <Button
              text={t("Click & Retrieve")}
              type="light"
              color={theme["primary-color"]}
              style={{ border: "1px solid currentcolor", height: 34 }}
              disabled={disableButton || fetchingVIBAN || loading}
              loading={fetchingVIBAN}
              onClick={() => {
                clientIBAN
                  ? creatingVIBAN({
                      contractId: +contractId,
                      clientIban: clientIBAN,
                    })
                      ?.unwrap()
                      ?.then(data => notification.success({ message: data?.message }))
                      ?.catch(e => notification?.error({ message: e?.message }))
                  : clientIbanRef?.current?.setVisible(true)
              }}
            />
            {error && (
              <IconText
                icon="AiFillWarning"
                iconProps={{ color: theme["error-color"], size: "1em" }}
                titleProps={{ color: theme["error-color"], style: { fontSize: "12px" } }}
                title={error?.message}
              />
            )}
            {disableButton && (
              <IconText
                icon="MdInfoOutline"
                iconProps={{ color: "#9d9d9d", size: "1em" }}
                titleProps={{ color: "#9d9d9d", style: { fontSize: "12px" } }}
                title={t("Bank details can only be generated once the token payment has been completed")}
              />
            )}
          </Flex>
        </>
      ) : (
        <>
          <Text type="secondary" className="mbe-20">
            {t(
              "Please share the bank information below with the customer to make payment. Once the payment is made it will automatically reflect in Propforce and you will be notified."
            )}
          </Text>
          <div style={{ marginBottom: "14px" }}>
            <DetailBar
              onlyInfoBlock
              listData={[
                {
                  label: (
                    <Flex justify="center" align="flex-start" vertical>
                      <Text className="semiBold" color={theme["gray700"]}>
                        {t("IBAN")}
                      </Text>
                      <Text className="semiBold">{vIBAN}</Text>
                    </Flex>
                  ),
                  data: (
                    <Flex align="center" gap={"16px"}>
                      <IconText
                        icon="RiFileCopyLine"
                        gap={"4px"}
                        iconProps={{ color: theme["primary-color"], onClick: () => copyToClipboard(vIBAN) }}
                        titleProps={{ style: { fontSize: "14px" } }}
                        title={t("Copy")}
                      />
                      <Flex gap={"2px"}>
                        <WhatsappCallButton client={{ id: clientId }} disabled={whatsappButtonDisabled} />
                        <Text>{t("Share")}</Text>
                      </Flex>
                    </Flex>
                  ),
                },
              ]}
              separator={false}
              bgColor={"#EFF8FC"}
              borderColor={"#0091BA"}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default IBANInfo
